import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { AngularSvgIconModule } from 'angular-svg-icon'
import { ButtonFlatModule, ButtonIconModule, ButtonStrokedModule } from '../../../shared/directives/button'
import { ConfirmModalComponent } from './confirm-modal.component'

@NgModule({
    declarations: [ConfirmModalComponent],
    exports: [ConfirmModalComponent],
    imports: [
        CommonModule,
        TranslateModule,
        ButtonFlatModule,
        ButtonStrokedModule,
        ButtonIconModule,
        AngularSvgIconModule
    ]
})
export class ConfirmModalModule {}
